import LoginOidcForm from './LoginOidcForm';

export default LoginOidcForm;


// WEBPACK FOOTER //
// ./src/features/login/components/login-oidc-form/index.js